// approvals 页面头部tab
export const approvalsTab = [
  {
    key: 'Applying',
    tabKey: 0,
    processDefinitionKeys: [
      'nike-mpp-catalyze-non-key-door-approval',
      'nike-mpp-key-door-approval',
      'nike-mpp-fww-reset-application-workflow-non-key',
    ],
  },
  {
    key: 'D&C',
    tabKey: 1,
    processDefinitionKeys: ['nike-mpp-design-construction', 'nike-mpp-fww-design-construction'],
  },
  {
    key: 'Closure',
    tabKey: 2,
    processDefinitionKeys: [
      'nike-mpp-closure-door-ae-approval',
      'nike-mpp-closure-door-mp-approval',
    ],
  },
]

export interface DoorSummaryTabItem {
  index: number
  key: string
  tabKey: number
  processDefinitionKeys: string[]
  row: number
}

// Door Summary 页面头部tab
export const doorSummaryTab: DoorSummaryTabItem[] = [
  {
    index: 0,
    key: 'All',
    tabKey: 7,
    processDefinitionKeys: [
      'nike-mpp-catalyze-non-key-door-approval',
      'nike-mpp-key-door-approval',
      'nike-mpp-fww-reset-application-workflow-non-key',
      'nike-mpp-design-construction',
      'nike-mpp-fww-design-construction',
      'nike-mpp-multi-energy-approval'
    ],
    row: 1,
  },
  {
    index: 1,
    key: 'Applying',
    tabKey: 0,
    processDefinitionKeys: [
      'nike-mpp-catalyze-non-key-door-approval',
      'nike-mpp-key-door-approval',
      'nike-mpp-fww-reset-application-workflow-non-key',
      'nike-mpp-multi-energy-approval'
    ],
    row: 1,
  },
  {
    index: 2,
    key: 'D&C',
    tabKey: 1,
    processDefinitionKeys: ['nike-mpp-design-construction', 'nike-mpp-fww-design-construction'],
    row: 1,
  },
  {
    index: 3,
    key: 'Closing',
    tabKey: 2,
    processDefinitionKeys: [
      'nike-mpp-closure-door-ae-approval',
      'nike-mpp-closure-door-mp-approval',
    ],
    row: 1,
  },
  {
    index: 4,
    key: 'Opened',
    tabKey: 3,
    processDefinitionKeys: [],
    row: 2,
  },
  {
    index: 5,
    key: 'Pending & Backup',
    tabKey: 5,
    processDefinitionKeys: [],
    row: 2,
  },
  {
    index: 6,
    key: 'Rejected & Dropped',
    tabKey: 4,
    processDefinitionKeys: [],
    row: 2,
  },
  {
    index: 7,
    key: 'Closed',
    tabKey: 6,
    processDefinitionKeys: [],
    row: 2,
  },
]

export enum ApprovalAction {
  Drop = 'Drop',
  Approve = 'Approve',
  Reject = 'Reject',
  Return = 'Return',
  Backup = 'Backup',
  Pending = 'Pending',
}

export const actionColorConfig: Record<ApprovalAction, string> = {
  [ApprovalAction.Drop]: '#808080',
  [ApprovalAction.Approve]: '#19BE6B',
  [ApprovalAction.Reject]: '#ED4014',
  [ApprovalAction.Return]: '#FF9900',
  [ApprovalAction.Backup]: '#FF9900',
  [ApprovalAction.Pending]: '#808080',
}

// 节点审批按钮
export const approveButtonConfig: Record<string, ApprovalAction[]> = {
  // Key Door
  'K1.1': [ApprovalAction.Approve, ApprovalAction.Drop],
  'K1.2': [ApprovalAction.Approve, ApprovalAction.Drop],
  'K2.1': [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  'K2.2': [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  K3: [ApprovalAction.Approve],
  'K4.1': [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  'K4.2': [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  K5: [ApprovalAction.Approve],
  K6: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  J7: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  K7: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  K8: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  K9: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  K10: [ApprovalAction.Approve, ApprovalAction.Drop],

  // Non- Key Door
  'N1.1': [ApprovalAction.Approve, ApprovalAction.Drop],
  'N1.2': [ApprovalAction.Approve, ApprovalAction.Drop],
  N2: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  N3: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  N4: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  N5: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  N6: [ApprovalAction.Approve, ApprovalAction.Backup, ApprovalAction.Drop],
  N7: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  J8: [ApprovalAction.Approve],
  J9: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  N8: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  'N9.1': [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Reject],
  'N10.1': [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Drop,
  ],
  'N10.2': [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Drop,
  ],
  'N10.3': [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Drop,
  ],
  'N10.4': [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Drop,
  ],

  // Design & Construction
  D1: [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Pending,
    ApprovalAction.Drop,
  ],
  D2: [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Pending,
    ApprovalAction.Drop,
  ],
  D3: [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Pending,
    ApprovalAction.Drop,
  ],
  D4: [
    ApprovalAction.Approve,
    ApprovalAction.Return,
    ApprovalAction.Reject,
    ApprovalAction.Pending,
    ApprovalAction.Drop,
  ],
  C0: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Pending, ApprovalAction.Drop],
  C1: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Pending, ApprovalAction.Drop],
  C2: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Pending, ApprovalAction.Drop],
  C3: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Pending, ApprovalAction.Drop],
  C4: [ApprovalAction.Approve, ApprovalAction.Return, ApprovalAction.Pending, ApprovalAction.Drop],

  // Closure
  CA1: [ApprovalAction.Approve],
  CA2: [ApprovalAction.Approve, ApprovalAction.Reject],
  CM1: [ApprovalAction.Approve],
  CM2: [ApprovalAction.Approve, ApprovalAction.Pending],
  CM3: [ApprovalAction.Approve, ApprovalAction.Return],
}

// 上一节点配置
export const lastGateConfig: Record<string, string> = {
  'K2.1': 'K1.1/K1.2',
  'K2.2': 'K1.1/K1.2',
  'K4.1': 'K3',
  'K4.2': 'K3',
  K6: 'K5',
  J7: 'K6',
  K7: 'K6',
  K8: 'K6',
  K9: 'K6',
  N2: 'N1.1/N1.2',
  N3: 'N1.1/N1.2',
  N4: 'N1.1/N1.2',
  N5: 'N4',
  'N10.2': 'N10.1',
  'N10.3': 'N10.2',
  'N10.4': 'N10.3',
  D2: 'D1',
  D3: 'D2',
  D4: 'D3',
  C0: 'D4',
  C1: 'D4',
  C2: 'C1',
  C3: 'C2',
  C4: 'C3',
  CM3: 'CM2',
}

// KIWI显示节点配置
export const kiwiConfig: string[] = ['K2.1', 'K2.2', 'K6', 'K7', 'K8', 'N2', 'N3', 'N4', 'N5', 'N7', 'N9.1']
